import axios from 'axios'
import { formatFileName, isEmpty } from 'src/views/utils/helper'
import { CHUNK_SIZE } from 'src/views/utils/constants'
const URL = process.env.REACT_APP_DOBBY_URL

const createChunks = (file) => {
  let startPointer = 0
  let endPointer = file.size
  let chunks = []
  while (startPointer < endPointer) {
    let newStartPointer = startPointer + CHUNK_SIZE
    chunks.push(file.slice(startPointer, newStartPointer))
    startPointer = newStartPointer
  }
  return chunks
}

export async function uploadToS3({ fileContents, data, fileType }) {
  // console.log(fileContents, data)
  let customerId = data.customer_id
  let signedUrlPayload = data
  signedUrlPayload.assets[0].file_name = formatFileName(data.assets[0].file_name)
  signedUrlPayload.assets[0].file_type = fileType
  let tempName = signedUrlPayload.assets[0].file_name
  let fileChunks = await createChunks(fileContents)
  signedUrlPayload.assets[0].num_parts = fileChunks.length

  const presignedPostUrl = await getPresignedPostUrl(signedUrlPayload)

  const SignedURLObj = presignedPostUrl.data[`${tempName}`].signed_url_dict
  const assetId = presignedPostUrl.data[`${tempName}`].asset_id
  const s3Key = presignedPostUrl.data[`${tempName}`].s3_key
  const jobId = presignedPostUrl.data[`job_id`]

  if (!isEmpty(SignedURLObj)) {
    let successCount = 0
    let ETagMap = {}
    let responseObj = {
      success: false,
      message: '',
      data: [],
    }
    let jobData = {}

    for (let idx = 0; idx < fileChunks.length; idx++) {
      const uploadChunk = fileChunks[idx]
      const AWSUploadResponse = await axios.put(SignedURLObj[idx + 1], uploadChunk)

      if (AWSUploadResponse.status === 200) {
        successCount++
        ETagMap[`${idx + 1}`] = AWSUploadResponse.headers?.etag
      }
    }

    if (successCount === fileChunks.length) {
      jobData[`${assetId}`] = { status: 'SUCCESS', etag_map: ETagMap }
      const jobUpdateRes = await updateJobStatus(jobData, jobId, customerId)
      if (jobUpdateRes.success) {
        responseObj = {
          success: true,
          message: 'Uploaded Succesfully!!',
          assetId,
          s3Key,
        }
      } else {
        responseObj = {
          success: false,
          message: jobUpdateRes.error,
        }
      }
      return responseObj
    } else {
      jobData[`${assetId}`] = { status: 'FAILED' }
      const jobUpdateRes = await updateJobStatus(jobData, jobId, customerId)

      if (jobUpdateRes.success) {
        responseObj = {
          success: false,
          message: 'Failed!!',
          data: [],
        }
      } else {
        responseObj = {
          success: false,
          message: jobUpdateRes.error,
        }
      }
      return responseObj
    }
  }

  return presignedPostUrl
}

export async function getPresignedPostUrl(data) {
  // console.log('data Action', data.files[0])
  try {
    const signedPostUrl = await axios({
      method: 'post',
      url: `${URL}/asset/upload`,
      data: data,
    })
    return signedPostUrl.data
  } catch (error) {
    console.log('Error')
    // if(error.response.status === 500){

    // }
    return error.data
  }
}

export async function getNetworkUploadSpeedApi(data) {
  try {
    await axios({
      method: 'post',
      url: `${URL}/speed-test-url`,
      data: data,
    })
    return ''
  } catch (error) {
    console.log('Error')
    return error.data
  }
}

export async function updateJobStatus(data, jobId, customerId) {
  try {
    const status = await axios({
      method: 'put',
      url: `${URL}/asset/upload?customer_id=${customerId}&job_id=${jobId}`,
      data: data,
    })
    // console.log('jobUpdate', status)
    return status.data
  } catch (error) {
    console.log('Error')
    return error.data
  }
}
